import { isEmpty } from 'lodash-es';
import { DateTime } from 'luxon';

import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import { createNlsMiddleware, lccstate } from '@holmescorp/lcc-state';

import css from '../css/update-banner.m.css';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export interface UpdateBannerProperties {}

const nlsSettings = createNlsMiddleware('settings');
const factory = create({
	theme,
	nlsSettings,
	lccstate
}).properties<UpdateBannerProperties>();

export const UpdateBanner = factory(({ properties, middleware: { theme, nlsSettings, lccstate } }) => {
	const themeCss = theme.classes(css);
	const { get, path } = lccstate;
	const {
		messages: {
			update_release_date = '',
			before_update_message = '[settings] before_update_message',
			after_update_message = '[settings] after_update_message',
			update_threshold = '3',
			update_url = ''
		}
	} = nlsSettings();

	if (isEmpty(update_release_date)) {
		return null;
	}

	const updateThreshold = parseInt(update_threshold);
	const updateReleaseDate = DateTime.fromISO(update_release_date);

	const sitestatus = get(path('sitestatus'));
	const { prior_login } = sitestatus;
	const lastLoginDate = prior_login in [null, undefined, ''] ? DateTime.now() : DateTime.fromSQL(prior_login);

	const beforeUpdateMessage = v('div', {
		key: 'update-banner',
		xqa: 'update-banner',
		classes: [themeCss.banner],
		innerHTML: before_update_message.replace('{update_url}', update_url)
	});

	const afterUpdateMessage = v('div', {
		key: 'update-banner',
		xqa: 'update-banner',
		classes: [themeCss.banner],
		innerHTML: after_update_message.replace('{update_url}', update_url)
	});

	const daysDiff = Math.floor(DateTime.now().setZone('local').diff(updateReleaseDate, 'days').days);
	const lastLoginDiff = Math.floor(lastLoginDate.diff(updateReleaseDate, 'days').days);

	return daysDiff >= -updateThreshold && daysDiff < 0
		? beforeUpdateMessage
		: daysDiff == 0 || (daysDiff >= 1 && lastLoginDiff <= 0) // If its after the release date, and last login was before the release date
		? afterUpdateMessage
		: null;
});
